import type { IConfigurationEntity, SettingsData } from "../../../interfaces";

export enum EDMSNextSettingKey {
    fileOpenPreference = "fileOpenPreference",
    showBreadcrumb = "showBreadcrumb",
    showTreeSearch = "showTreeSearch",
    searchConfigUrl = "searchConfigUrl",
    namingRulesUrl = "namingRulesUrl",
    viewRulesUrl = "viewRulesUrl",
    containerConfigUrl = "containerConfigUrl",
    createStructureConfigUrl = "createStructureConfigUrl",
    favoritesUrl = "favoritesUrl",
    showWhatsNewAfterUpdate = "showWhatsNewAfterUpdate"
}

export const fileOpenPreference = [
    { key: 0, text: "Preview only" },
    { key: 1, text: "Open in App" },
    { key: 2, text: "Open in Browser" }];

export const DMSNextSetting: Record<EDMSNextSettingKey, IConfigurationEntity> = {
    [EDMSNextSettingKey.fileOpenPreference]:
    {
        key: EDMSNextSettingKey.fileOpenPreference,
        name: "File open preference",
        shortDescription: "File open preference when clicking on files",
        defaultValue: 0,
        type: "number"
    },
    [EDMSNextSettingKey.showBreadcrumb]: {
        key: EDMSNextSettingKey.showBreadcrumb,
        name: "Show breadcrumb",
        shortDescription: "Show breadcrumb above file list",
        defaultValue: true,
        type: "boolean"
    },
    [EDMSNextSettingKey.showTreeSearch]: {
        key: EDMSNextSettingKey.showTreeSearch,
        name: "Show tree view search",
        shortDescription: "Show search in tree view area",
        defaultValue: true,
        type: "boolean"
    },
    [EDMSNextSettingKey.namingRulesUrl]: {
        key: EDMSNextSettingKey.namingRulesUrl,
        name: "Remote path for upload naming rules",
        shortDescription: "URL for upload naming rules",
        defaultValue: "",
        type: "string"
    },
    [EDMSNextSettingKey.searchConfigUrl]: {
        key: EDMSNextSettingKey.searchConfigUrl,
        name: "Remote path for search panels and configurations",
        shortDescription: "Custom search panels",
        defaultValue: "",
        type: "string"
    },
    [EDMSNextSettingKey.viewRulesUrl]: {
        key: EDMSNextSettingKey.viewRulesUrl,
        name: "Remote path for automatic view selection rules",
        shortDescription: "Rules with specific trigger conditions that can override the default SharePoint view selection, to automatically select a specific View.",
        defaultValue: "",
        type: "URL"
    },
    [EDMSNextSettingKey.containerConfigUrl]: {
        key: EDMSNextSettingKey.containerConfigUrl,
        name: "Remote path for container configuration",
        shortDescription: "Controls visibility for TreeView nodes and FileList containers",
        defaultValue: "",
        type: "URL"
    },
    [EDMSNextSettingKey.createStructureConfigUrl]: {
        key: EDMSNextSettingKey.createStructureConfigUrl,
        name: "Remote path for create structure configuration",
        shortDescription: "Folder structures that can be quickly created for specific locations",
        defaultValue: "",
        type: "URL"
    },
    [EDMSNextSettingKey.favoritesUrl]: {
        key: EDMSNextSettingKey.favoritesUrl,
        name: "Remote path for Sync Favorites",
        defaultValue: "",
        shortDescription: "URL for Sync Favorites",
        type: "URL"
    },
    [EDMSNextSettingKey.showWhatsNewAfterUpdate]: {
        key: EDMSNextSettingKey.showWhatsNewAfterUpdate,
        name: "Show what's new after each update",
        shortDescription: "Displays release notes dialog after app update",
        defaultValue: true,
        type: "boolean"
    }
};

export const DMSNextDefaultSettings: SettingsData = {

};